import { api, qs } from '../client'
import type {
  AdminReport,
  AdminUser,
  ModerationAction,
  Page,
  Report,
  ReportAction,
  ReportReason,
  ReportStatus,
} from '../types'

export interface CreateReportInput {
  /** 帖子与用户二选一 */
  post_id?: string
  username?: string
  reason: ReportReason
  note?: string
}

/** 举报（任何登录用户）。只进人工审核队列，不自动处置任何东西（D67） */
export const reportsApi = {
  create: (input: CreateReportInput) =>
    api.post<{ report: Report }>('/reports', input).then((r) => r.report),
}

/** 管理接口（D68）：只认管理员 + 网页会话 */
export const adminApi = {
  reports: (status: ReportStatus, cursor?: string, limit = 20) =>
    api.get<Page<AdminReport>>(`/admin/reports${qs({ status, cursor, limit })}`),

  resolve: (id: string, action: ReportAction, note = '') =>
    api
      .post<{ report: AdminReport }>(`/admin/reports/${id}/resolve`, { action, note })
      .then((r) => r.report),

  removePost: (postId: string, note = '') =>
    api.post<{ ok: boolean }>(`/admin/posts/${postId}/remove`, { note }),

  suspend: (username: string, note = '') =>
    api
      .post<{ user: AdminUser }>(`/admin/users/${encodeURIComponent(username)}/suspend`, { note })
      .then((r) => r.user),

  unsuspend: (username: string, note = '') =>
    api
      .post<{ user: AdminUser }>(`/admin/users/${encodeURIComponent(username)}/unsuspend`, {
        note,
      })
      .then((r) => r.user),

  user: (username: string) =>
    api
      .get<{ user: AdminUser }>(`/admin/users/${encodeURIComponent(username)}`)
      .then((r) => r.user),

  actions: (cursor?: string, limit = 20) =>
    api.get<Page<ModerationAction>>(`/admin/actions${qs({ cursor, limit })}`),
}
